import { SPONSORED_LISTINGS_LIMIT, CSP_BUMP_LISTING_LIMIT } from '../constants';
import { Listing, CspFiltersAndListingsQuery } from '../../../schemas/rql';

interface IGetSponsoredListingsArgs {
  cspSponsoredListing: CspFiltersAndListingsQuery.CspSponsoredListing;
  featuredListing: Listing;
  bumpedListings?: Listing[];
}

export function getSponsoredListings({ cspSponsoredListing, featuredListing, bumpedListings = [] }: IGetSponsoredListingsArgs) {
  const sponsored = cspSponsoredListing ?? {};
  const sponsoredSecondPlace = sponsored?.runnerUp ?? {};
  const sponsoredThirdPlace = sponsoredSecondPlace?.runnerUp ?? {};

  const sponsoredListingCandidates = [
    sponsored.listing,
    sponsoredSecondPlace.listing,
    sponsoredThirdPlace.listing,
  ];

  const eligibleSponsoredListings = sponsoredListingCandidates.filter(listing =>
    !!listing &&
    listing.id !== featuredListing?.id,
  );

  const sponsoredListingIds = eligibleSponsoredListings.map(listing => listing.id);
  const totalSponsoredListings = eligibleSponsoredListings.length;
  const totalBumpedListingsToInclude = totalSponsoredListings > CSP_BUMP_LISTING_LIMIT ? 0 : CSP_BUMP_LISTING_LIMIT - totalSponsoredListings;

  const filteredBumpListings = bumpedListings.filter(listing => !sponsoredListingIds.includes(listing.id));

  return eligibleSponsoredListings.concat(
    filteredBumpListings.slice(0, totalBumpedListingsToInclude),
  ).slice(0, SPONSORED_LISTINGS_LIMIT);
}
